/**
 * Created by andrey on 29.01.19.
 */

const Cup = function (type, innerCup) {
    cleverapps.EventEmitter.call(this);

    this.type = type;
    this.name = `${cleverapps.config.name}_${this.type}`;
    this.config = CupsConfig.TYPES[this.type];
    this.innerCup = innerCup;

    if (!CupsConfig.IsEnabled(this.type)) {
        return;
    }

    this.load();

    this.reload(true);
    cleverapps.timeouts.setInterval(this.reload.bind(this), Cup.RELOAD_INTERVAL);

    this.onChangeResults = function () {};

    this.cupDataSource = new CupDataSource(this);
    this.table = new ScrollTable(this.cupDataSource);

    if (!this.config.participateAsClan) {
        cleverapps.settings.on("changedAvatar", this.updateProfile.bind(this), this);
        cleverapps.settings.on("changedNickname", this.updateProfile.bind(this), this);
    }

    cleverapps.user.on("recheckAvailable", () => {
        if (this.state === Cup.STATE_PENDING) {
            this.reload(true);
        }
    }, this);
};

Cup.prototype = Object.create(cleverapps.EventEmitter.prototype);
Cup.prototype.constructor = Cup;

Cup.prototype.load = function () {
    let info = cleverapps.dataLoader.load(DataLoader.TYPES.CUP + this.type);

    info = info || {};

    this.participantId = info.participantId;
    this.id = info.id;
    this.start = info.start || 0;
    this.end = info.end || 0;
    this.score = info.score || info.stars || 0;
    this.delta = info.delta || 0;
    this.state = info.state === undefined ? Cup.STATE_PENDING : info.state;
    this.participants = [];

    clearTimeout(this.timeout);

    const timeLeft = this.getTimeLeft();
    if (timeLeft) {
        this.timeout = new cleverapps.LongTimeout(this.reload.bind(this), timeLeft);
    }
};

Cup.prototype.save = function () {
    const info = {
        participantId: this.participantId,
        id: this.id,
        start: this.start,
        end: this.end,
        score: this.score,
        delta: this.delta,
        state: this.state
    };

    cleverapps.dataLoader.save(DataLoader.TYPES.CUP + this.type, info);
};

Cup.prototype.next = function () {
    this.state = Cup.STATE_PENDING;
    this.save();
    this.trigger("update");

    this.reload();

    if (this.innerCup) {
        this.innerCup.next();
    }
};

Cup.prototype.startNewCup = function ({ cupId, start }) {
    this.id = cupId;
    this.start = start;
    this.delta = 0;
    this.score = 0;
    this.participantId = connector.platform.getUserID();
    this.participants = [];
    this.state = Cup.STATE_RUNNING;
    this.wantsToShow = true;

    Cup.DailyCupLeadersCache = undefined;

    this.save();
};

Cup.prototype.updateCup = function (data) {
    if (!data) {
        this.state = Cup.STATE_PENDING;
        this.save();
        return;
    }

    this.end = Date.now() + data.time || 0;
    this.score = data.score + this.delta || 0;
    this.participants = data.participants || [];

    clearTimeout(this.timeout);

    const timeLeft = this.getTimeLeft();
    if (timeLeft) {
        this.state = Cup.STATE_RUNNING;
        this.timeout = new cleverapps.LongTimeout(this.reload.bind(this), timeLeft);
    } else if (this.state === Cup.STATE_RUNNING) {
        this.state = Cup.STATE_FINISHED;

        if (!this.getReward()) {
            this.state = Cup.STATE_RECEIVED;
            this.wantsToShow = false;
        }

        Cup.DailyCupLeadersCache = undefined;
    }

    this.save();
};

Cup.prototype.isAvailable = function (options) {
    return CupsConfig.IsEnabled(this.type) && cleverapps.user.checkAvailable(this.config.available, options);
};

Cup.prototype.isActive = function () {
    return this.state !== Cup.STATE_PENDING;
};

Cup.prototype.isRunning = function () {
    return this.state === Cup.STATE_RUNNING && this.getTimeLeft();
};

Cup.prototype.isFinished = function () {
    return this.state !== Cup.STATE_RUNNING;
};

Cup.prototype.hasConnection = function () {
    return !this.noConnection;
};

Cup.prototype.getTimeLeft = function () {
    return Math.max(0, this.end - Date.now());
};

Cup.prototype.getParticipantInfo = function () {
    if (this.config.participateAsClan && cleverapps.userClan) {
        return {
            id: cleverapps.userClan.id,
            name: cleverapps.userClan.name,
            avatar: cleverapps.userClan.emblem
        };
    }

    const playerInfo = cleverapps.user.getPlayerInfo();

    return {
        id: playerInfo.id,
        name: playerInfo.name,
        avatar: playerInfo.avatar
    };
};

Cup.prototype.updateProfile = function () {
    if (!this.isRunning() || !this.id || cleverapps.flags.nomulti) {
        return;
    }

    const info = this.getParticipantInfo();

    connector.multi.cups.updateProfile(this.id, this.participantId, {
        name: info.name,
        avatar: info.avatar
    });
};

Cup.prototype.reload = function (force) {
    if (this.reloading || !this.isAvailable() || !force && !cleverapps.environment.hasScene(this.config.scenes)) {
        return;
    }

    if (this.state === Cup.STATE_RECEIVED && this.end + this.config.restartAfter < Date.now()) {
        this.next();
        return;
    }

    if (cleverapps.flags.nomulti) {
        this.noConnection = true;
        this.trigger("update");
        return;
    }

    this.reloading = true;

    const player = new ActionPlayer([
        (f, stop) => {
            if (this.state === Cup.STATE_PENDING) {
                const country = cleverapps.country.getCountry() || "unknown";
                const participantInfo = this.getParticipantInfo();

                connector.multi.cups.join(this.name, country, {
                    userId: connector.platform.getUserID(),
                    name: participantInfo.name,
                    avatar: participantInfo.avatar
                }, (cup) => {
                    if (cup) {
                        this.startNewCup(cup);

                        f();
                    } else {
                        stop();
                    }
                });
            } else {
                f();
            }
        },

        (f) => {
            connector.multi.cups.get(this.id, this.participantId, (success, cup) => {
                if (success) {
                    this.noConnection = false;
                    this.updateCup(cup);
                    this.trigger("update");
                }

                f();
            });
        },

        (f) => {
            if (this.delta === 0) {
                f();

                return;
            }

            const delta = this.delta;
            this.delta = 0;
            this.save();

            connector.multi.cups.postScore(this.id, this.participantId, delta, (success) => {
                if (!success) {
                    this.delta += delta;
                }

                f();
            });
        }
    ]);

    player.onFailure(() => {
        this.reloading = false;
        this.noConnection = true;
        this.trigger("update");
    });

    player.play(() => {
        this.reloading = false;
    });
};

Cup.prototype.addAmount = function (score) {
    if (!this.isRunning() || !score) {
        return;
    }

    this.score += score;
    this.delta += score;
    this.save();
    this.trigger("update");
};

Cup.prototype.calcPlace = function () {
    if (!this.score) {
        return;
    }

    for (let i = 0; i < this.participants.length; i++) {
        const participant = this.participants[i];

        if (participant.id === this.participantId) {
            return i;
        }

        if (participant.score < this.score) {
            return i;
        }
    }
    return this.participants.length;
};

Cup.prototype.listRewards = function () {
    return this.config.rewards;
};

Cup.prototype.getReward = function () {
    if (this.state === Cup.STATE_FINISHED) {
        const rewards = this.listRewards();
        const place = this.calcPlace();
        return rewards[place];
    }
};

Cup.createRewardWindow = function (reward, type) {
    return new RewardWindow(reward, {
        name: "cupsrewardwindow",
        title: Messages.get(`Cups.${type}.title`),
        text: Messages.get(`Cups.${type}.reward`),
        event: cleverapps.EVENTS.EARN.OTHER
    });
};

Cup.prototype.receiveReward = function (f) {
    const reward = this.getReward();
    const place = this.calcPlace();
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CUP_REWARD + this.type}_${this.start}_${place + 1}`);

    Cup.createRewardWindow(reward, this.type);
    cleverapps.focusManager.onceNoWindowsListener = f;

    this.state = Cup.STATE_RECEIVED;
    this.save();
    this.trigger("update");
};

Cup.prototype.withLives = function () {
    return cleverapps.lives && cleverapps.config.type !== "board";
};

Cup.prototype.wantsToPlay = function (f) {
    let level = cleverapps.user.getRandomLevel({ seed: (this.start || 0) * 1000 + (this.score || 0), type: Level.LevelTypes.DAILYCUP });

    while (level.isBonus() && level.getHumanReadableNumber() > 1) {
        level = Level.CreateByNumber(level.getHumanReadableNumber() - 2, { type: Level.LevelTypes.DAILYCUP });
    }

    Level.WantsToPlay(f, {
        level
    });
};

Cup.prototype.getForce = function () {
    return this.config.force;
};

Cup.prototype.needsAttention = function () {
    const place = this.calcPlace();
    return this.getReward() || place !== undefined && place !== this.lastShownPlace;
};

Cup.prototype.afterWindowShown = function () {
    this.wantsToShow = false;
    this.lastShownPlace = this.calcPlace();
};

Cup.STATE_RUNNING = 0;
Cup.STATE_FINISHED = 1;
Cup.STATE_RECEIVED = 2;
Cup.STATE_PENDING = 3;

Cup.RELOAD_INTERVAL = cleverapps.parseInterval("30 seconds");
